<script setup>
const route = useRoute()

const props = defineProps({
  sort: {
    type: String,
    default: 'project'
  }
})

const { data: hubData } = await useAsyncData('hubs_menu', () => {

  const query = queryCollection('content')
  .where('path', 'LIKE', '/projects%')
  .where('content_type', '=', ContentTypeEnum.Hub)
  .order(props.sort, 'ASC')

  if(import.meta.env.PROD) {
    query.where('published', '==', PublishedStatusEnum.Published)
  }

  return query.all()
});


const hubs = hubData.value && hubData.value.length ? [...hubData.value] : []

logger.log(`HubsMenu fetched ${hubs.length} hubs.`)
</script>

<template>
  <ul class="flex flex-row space-x-3 md:space-x-4">
    <li v-for="hub in hubs" :key="hub.project">
      <NuxtLink 
        :to="hub.path" 
        :class="route.path.startsWith(hub.path) ? 'current link' : 'link'"
      >
        {{ hub.title }}
      </NuxtLink>
    </li>
  </ul>
</template>

<style lang="css" scoped>
.link {
  @apply p-1 hover:bg-gray-200 dark:hover:bg-gray-800 text-sm md:text-base font-mono
}

.current {
  @apply border border-green-600 border-l-0 border-t-0 border-r-0
}

</style>